import { mapGetters, mapState } from 'vuex';

var infiniteScroll = require('vue-infinite-scroll');

export default {
  name: 'SearchCard',
  directives: { infiniteScroll },
  props: {},
  data() {
    return {
      initialized: false,
      searchWindowOpen: false,
      loadingPhotos: false,
      otherProfilesResults: [],
      busy: true,
      noMoreResults: false,
      loading: false,
      tabHash: {
        1: '#Neighbours',
        2: '#Visitors',
        3: '#TopChoice',
      },
      urls: {
        1: 'ajax.profiles.search',
        2: 'ajax.profiles.visitors',
        3: 'ajax.profiles.top-choice',
        4: 'ajax.profiles.more-search',
      },
      activeTab: 1,
      form: {
        age: [20, 40],
        genders: [],
        show_girls: true,
        show_boys: true,
        nickname: null,
        age_from: 18,
        age_to: 30,
        location_id: null,
        distance: 50,
      },
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    ...mapGetters('members', {
      membersResults: 'getResults',
      membersPage: 'getPage',
    }),
    ...mapGetters('visitors', {
      visitorsResults: 'getResults',
      visitorsPage: 'getPage',
    }),
    ...mapGetters('topChoices', {
      topChoicesResults: 'getResults',
      topChoicesPage: 'getPage',
    }),
    showMoreResults: function () {
      return this.activeTab === 1 && this.otherProfilesResults.length > 0;
    },
    searchResults: function () {
      if (this.activeTab === 1) {
        return this.membersResults;
      } else if (this.activeTab === 2) {
        return this.visitorsResults;
      } else if (this.activeTab === 3) {
        return this.topChoicesResults;
      }
    },
  },
  watch: {
    form: {
      handler() {
        if (this.initialized === false) {
          return;
        }

        this.autoSearch();
      },
      deep: true,
    },
    'form.genders': function (newValue, oldVale) {
      if (newValue.length >= 1) {
        return;
      }

      if (oldVale.length === 0 && newValue.length === 0) {
        this.form.genders = ['female', 'male'];
        return;
      }

      if (oldVale.length >= 1 && newValue.length === 0) {
        if (oldVale[0] === 'female')
          this.form.genders = ['male'];
        if (oldVale[0] === 'male')
          this.form.genders = ['female'];
      }
    },
    searchWindowOpen: function (oldVale, newValue) {
      if (newValue === true) {
        $('#tab-neighbours, #tab-top-choice, #tab-visitors').removeClass('d-none d-md-inline-block');
        $('#more-results').removeClass('d-none d-md-flex');
        $('.search-members-box').removeClass('mt-5 pt-3 pt-md-0 mt-md-0');
      } else {
        $('#tab-neighbours, #tab-top-choice, #tab-visitors').addClass(' d-md-inline-block');
        $('#more-results').addClass('d-none d-md-flex');
        $('.search-members-box').addClass('mt-5 pt-3 pt-md-0 mt-md-0');
      }
    },
    noMoreResults: function (newValue, oldVale) {
      let vm = this;
      if (newValue && (this.membersResults.length < 8)) {
        const excludeIds = this.membersResults.map(r => r.id);

        axios
          .post(zRoute(this.urls[4]) + '?page=1', {
            genders: vm.form.genders,
            excluded_id: excludeIds,
          })
          .then(response => {
            if (response.data.data.length) {
              this.otherProfilesResults = response.data.data;
            }
          });
      } else {
        this.otherProfilesResults = [];
      }
    },
  },
  methods: {
    search() {
      this.activeTab = 1;
      this.reset();
      this.load();
    },
    autoSearch: _.debounce(function () {
      this.search();
    }, 500),
    reset() {
      this.$store.commit('members/setResults', []);
      this.$store.commit('members/setPage', 0);

      this.busy = false;
      this.noMoreResults = false;
      this.loading = false;
    },
    /**
     *
     * @param store ['members', 'visitors', 'topChoices']
     * @param url
     * @param params
     */
    callRequest(store, url, params = {}) {
      if (this.initialized === false) {
        return;
      }

      if (this.$store.getters[store + '/getPage'] === 0) {
        this.loadingPhotos = true;
      }

      this.loading = true;

      let form = this.form;
      form.excluded_id = this.$store.getters[store + '/getResultsIds'];

      this.$store.commit(store + '/incrementPage');
      params.page = this.$store.getters[store + '/getPage'];

      axios
        .post(zRoute(url) + '?' + (new URLSearchParams(params).toString()), form)
        .then(response => {
          if (response.data.data.length) {
            response.data.data.forEach(profile => {
              this.$store.commit(store + '/pushResult', profile);
            });

            this.noMoreResults = false;
            this.busy = false;
            this.loadingPhotos = false;
          } else {
            this.noMoreResults = true;
          }

          this.loading = false;
          this.loadingPhotos = false;
        });
    },
    callVisitorsRequest() {
      this.callRequest('visitors', this.urls[2]);
    },
    callTopChoicesRequest() {
      this.callRequest('topChoices', this.urls[3]);
    },
    callMembersRequest() {
      this.callRequest('members', this.urls[1], { limit: 24 });
    },
    load: function () {
      this.busy = true;

      if (this.activeTab === 1) {
        this.callMembersRequest();
      }

      if (this.activeTab === 2) {
        this.callVisitorsRequest();
      }

      if (this.activeTab === 3) {
        this.callTopChoicesRequest();
      }
    },
    loadMore: function () {
      this.busy = true;

      this.load();
    },
    getClonedForm() {
      return {
        age: this.form.age,
        age_from: this.form.age_from,
        age_to: this.form.age_to,
        agreement: this.form.agreement,
        distance: this.form.distance,
        excluded_id: this.form.excluded_id,
        genders: this.form.genders,
        location_id: this.form.location_id,
        nickname: this.form.nickname,
        show_boys: this.form.show_boys,
        show_girls: this.form.show_girls,
      };
    },
    openBuyModal: function ({ profileId, isOther, profileAvatar }) {
      let form = this.getClonedForm();
      form.is_other = this.isOther;
      this.$eventHub.$emit('BuyProfileModalOpen', { profileId: profileId, form: form, avatarUrl: profileAvatar });
    },
    buyProfile: function (profile) {
      this.$store.commit('members/setProfile', profile);
      this.$store.commit('visitors/setProfile', profile);
      this.$store.commit('topChoices/setProfile', profile);

      let index = this.otherProfilesResults.findIndex((x) => {
        return x.id === profile.id;
      });
      this.$set(this.otherProfilesResults, index, profile);
    },
    selectTab(hash) {
      if (hash) {
        const entry = Object.entries(this.tabHash).find(x => x[1] === hash);
        if (entry) {
          this.activeTab = parseInt(entry[0]);
        }
      }
    }
  },
  mounted() {
    let vm = this;
    this.selectTab(window.location.hash);

    const searchAttr = this.user.search;
    if (searchAttr) {
      this.form.genders = searchAttr.genders || [];
      this.form.age_from = searchAttr.age_from || 20;
      this.form.age_to = searchAttr.age_to || 40;
      this.form.location_id = searchAttr.location_id || (this.user.location ? this.user.location.id : null);
      this.form.distance = searchAttr.distance || 50;
    }

    this.$nextTick(() => {
      if (window.location.hash === '#search') {
        this.searchWindowOpen = true;
      }

      this.initialized = true;
      this.busy = false;

      if (this.searchResults.length === 0) {
        this.loadMore();
      }
    });

    vm.$eventHub.$on('FreshProfile', (profile) => {
      vm.buyProfile(profile);
    });

    vm.$eventHub.$on('MembersSearchDuplicated', () => {
      const values = this.searchResults.slice(0);
      const valueArr = values.map(function (item) {
        return item.id;
      });
      const duplicates = valueArr.filter(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });

      console.log(duplicates);
    });

    vm.$eventHub.$on('MembersSearchNaN', () => {
      const values = this.searchResults.slice(0);

      const withoutDistance = values.filter(function (item, idx) {
        return item.location && item.location.distance === null;
      });

      const ids = withoutDistance.map(function (item) {
        return item.id;
      });

      console.log(ids);
    });
  }
};
